import React from "react";
import { Container, Typography, Divider, Box, Button } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

export default function WriteToUs() {
    const handleEmailClick = () => {
        const user = "szilamer";
        const domain = "szekler-resources.ro";
        const subject = "Kapcsolatfelvétel – Székely Nemzet Online";

        window.location.href = `mailto:${user}@${domain}?subject=${encodeURIComponent(subject)}`;
    };

    return (
        <Container maxWidth="md" sx={{ mt: '50px', py: 4 }}>
            <Typography variant="h3" gutterBottom>
                Írjon nekünk
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography paragraph>
                Ha kérdése, észrevétele vagy javaslata van,
                örömmel fogadjuk üzenetét.
            </Typography>

            <Typography paragraph>
                Célunk a Székely Nemzet Online folyamatos fejlesztése,
                amelyhez a felhasználói visszajelzések kiemelten fontosak.
            </Typography>

            <Box sx={{ mt: 4, textAlign: "center" }}>
                <Button
                    variant="contained"
                    startIcon={<EmailIcon />}
                    onClick={handleEmailClick}
                >
                    E-mail küldése
                </Button>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 2 }}
                >
                    Az üzenet az alapértelmezett levelezőprogramjában fog megnyílni.
                </Typography>
            </Box>
        </Container>
    );
}
